import fp from 'lodash/fp';
import React from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardImg, CardSubtitle, CardTitle, Col, Container, Jumbotron, Row } from 'reactstrap';
import { compose, pure, withProps } from 'recompose';
import { routes } from '../../../../constants';
import './artists.css';
import artistsQuery from './artists.gql';

const Artists = ({ data: { artists } }) => (
  <section className='artists'>
    <Jumbotron tag='section' className='text-center'>
      <Container>
        <h1>Artists</h1>
      </Container>
    </Jumbotron>
    <div className='album text-muted'>
      <Container>
        {
          fp.flow(
            fp.sortBy(({ name }) => name),
            fp.chunk(3),
            fp.map((chunk) =>
              <Row key={fp.flow(fp.map(({ id }) => id), fp.join(' '))(chunk)}>
                {
                  fp.map(({
                    currentLocation: {
                      country: currentCountry
                    },
                    id,
                    name,
                    originalLocation,
                    profileImage
                  }) =>
                    <Col key={id} xs={12} md={4}>
                      <Card>
                        <Link to={routes.artist(id)}>
                          <CardImg top width='100%' src={profileImage} />
                        </Link>
                        <CardBody>
                          <CardTitle className='text-center'>
                            <Link to={routes.artist(id)}>
                              {
                                (([firstName, ...lastName]) =>
                                  [
                                    firstName,
                                    <br key='break' />,
                                    fp.join(' ')(lastName)
                                  ]
                                )(fp.words(name))
                              }
                            </Link>
                          </CardTitle>
                          <CardSubtitle className='text-center'>
                            {fp.flow(
                              fp.filter(fp.identity),
                              fp.uniq,
                              fp.join(' / ')
                            )([fp.get('country')(originalLocation), currentCountry])}
                          </CardSubtitle>
                        </CardBody>
                      </Card>
                    </Col>
                  )(chunk)
                }
              </Row>
            )
          )(artists)
        }
      </Container>
    </div>
  </section>
);

export default compose(
  withProps(() => ({
    filter: {}
  })),
  graphql(artistsQuery),
  pure
)(Artists);



// WEBPACK FOOTER //
// ./src/components/pages/app/artists/artists.js